import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Modal } from "bootstrap";
import { toast } from "react-toastify";
import { createTransactionPin } from "../../actions/user";
import TransactionPinModal from "../TransactionPinModal";

const TransactionPin = () => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(1); // 1 = Set PIN, 2 = Confirm PIN
  const [firstPin, setFirstPin] = useState("");
  const [, setLoading] = useState(false);
  const transitionRef = useRef(false);

  useEffect(() => {
    const modalEl = document.getElementById("transactionPinModal");
    if (!modalEl) return;

    const handleShow = () => {
      if (!transitionRef.current) {
        setStep(1);
        setFirstPin("");
      }
    };

    modalEl.addEventListener("show.bs.modal", handleShow);
    return () => {
      modalEl.removeEventListener("show.bs.modal", handleShow);
    };
  }, []);

  const handlePinSubmit = async (enteredPin) => {
    if (step === 1) {
      setFirstPin(enteredPin);
      setStep(2);
      transitionRef.current = true;
      setTimeout(() => {
        const modalEl = document.getElementById("transactionPinModal");
        if (modalEl) {
          const modal = Modal.getOrCreateInstance(modalEl);
          modal.show();
        }
        transitionRef.current = false;
      }, 400);
    } else {
      if (enteredPin !== firstPin) {
        toast.error("PINs do not match. Please try again.", {
          className: "custom-toast",
        });
        setStep(1);
        setFirstPin("");
        return;
      }

      const credentials = {
        pin: enteredPin,
        pin_confirmation: enteredPin,
      };

      setLoading(true);
      try {
        await createTransactionPin(
          credentials,
          setLoading,
          (msg) => {
            if (msg) toast.success(msg, { className: "custom-toast" });
          },
          () => {},
          dispatch
        );
        setStep(1);
        setFirstPin("");
      } catch (error) {
        toast.error(
          error.response?.data?.message?.message ||
            error.response?.data?.message ||
            "Failed to update PIN. Please try again.",
          { className: "custom-toast" }
        );
        setStep(1);
        setFirstPin("");
      }
    }
  };

  const title = step === 1 ? "Set Transaction PIN" : "Confirm Transaction PIN";
  const description = step === 1
    ? "Enter your 4-digit PIN to securely proceed."
    : "Re-enter your 4-digit PIN to confirm.";

  return (
    <TransactionPinModal
      id="transactionPinModal"
      onSubmit={handlePinSubmit}
      title={title}
      description={description}
    />
  );
};

export default TransactionPin;

